/**
 * @file 自适应弹性布局
 */
import { useEffect } from 'react'
import { FlexibleBase } from '@/constants'

export default function useFlexible() {
  const recalc = () => {
    const docEl = document.documentElement
    const { clientWidth, clientHeight } = docEl
    if (!clientWidth || !clientHeight) return
    // 适配方案
    // const fs = Math.min(100 * (clientWidth / 667), 100 * (clientHeight / 375))
    const fs = Math.min(100 * (clientWidth / FlexibleBase), 80)
    docEl.style.fontSize = `${fs}px`
    const rootDOM = document.querySelector('#root') as HTMLImageElement
    rootDOM.style.display = 'block'
  }

  useEffect(() => {
    recalc()
    const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
    window.addEventListener(resizeEvt, recalc, false)
    document.addEventListener('DOMContentLoaded', recalc, false)

    return () => {
      window.removeEventListener(resizeEvt, recalc, false)
      document.removeEventListener('DOMContentLoaded', recalc, false)
    }
  }, [document, window])

  return { recalc }
}
